(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rd26_new-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.new-faq-content details summary').forEach((summary) => {
    summary.addEventListener('click', (e) => {
      e.preventDefault();

      const details = summary.parentElement;
      const all = document.querySelectorAll('.new-faq-content details');

      const open = (el) => {
        const answer = el.querySelector('.faq-answer');

        el.open = true;
        answer.style.marginTop = '';
        el.dispatchEvent(new Event('toggle'));

        requestAnimationFrame(() => {
          const toHeight = answer.scrollHeight;

          answer.style.transition = 'none';
          answer.style.height = '0px';
          answer.offsetHeight; // force reflow

          answer.style.transition = '';
          answer.style.height = toHeight + 'px';

          answer.addEventListener(
            'transitionend',
            () => {
              answer.style.height = 'auto';
            },
            { once: true }
          );
        });
      };

      const close = (el) => {
        const answer = el.querySelector('.faq-answer');
        el.classList.add('closing');

        const fromHeight = answer.offsetHeight;

        answer.style.transition = 'none';
        answer.style.height = fromHeight + 'px';
        answer.style.marginTop = '0';
        answer.offsetHeight; // force reflow

        answer.style.transition = '';
        answer.style.height = '0px';

        answer.addEventListener(
          'transitionend',
          () => {
            el.classList.remove('closing');
            el.open = false;
            el.dispatchEvent(new Event('toggle'));
            answer.style.height = '';
            answer.style.marginTop = '';
          },
          { once: true }
        );
      };

      all.forEach((el) => {
        if (el !== details && el.open) close(el);
      });
      details.open ? close(details) : open(details);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd26_product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initTabs(root) {
      if (!root || root.dataset.rd26TabsInitialized === 'true') return;

      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      if (!tabs.length) return;

      function activate(targetId, focusTab) {
        tabs.forEach(function (tab) {
          var isActive = tab.dataset.tabTarget === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (isActive && focusTab) tab.focus();
        });

        panels.forEach(function (panel) {
          var isActive = panel.dataset.panelId === targetId;
          panel.classList.toggle('is-active', isActive);
          if (isActive) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });

        root.dispatchEvent(
          new CustomEvent('rd26:tab-change', {
            bubbles: true,
            detail: { tabId: targetId, sectionId: root.dataset.sectionId },
          })
        );
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(tab.dataset.tabTarget, false);
        });

        tab.addEventListener('keydown', function (event) {
          var newIndex = null;
          switch (event.key) {
            case 'ArrowRight':
              newIndex = (index + 1) % tabs.length;
              break;
            case 'ArrowLeft':
              newIndex = (index - 1 + tabs.length) % tabs.length;
              break;
            case 'Home':
              newIndex = 0;
              break;
            case 'End':
              newIndex = tabs.length - 1;
              break;
          }
          if (newIndex !== null) {
            event.preventDefault();
            activate(tabs[newIndex].dataset.tabTarget, true);
          }
        });
      });

      root.dataset.rd26TabsInitialized = 'true';
    }

    function bootAll() {
      document.querySelectorAll('[data-rd26-product-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', bootAll);
    document.addEventListener('shopify:block:select', function (event) {
      var sectionEl = document.querySelector(
        '[data-rd26-product-tabs][data-section-id="' + event.detail.sectionId + '"]'
      );
      if (!sectionEl) return;
      var tab = sectionEl.querySelector('[data-tab-target="' + event.detail.blockId + '"]');
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
